import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../utils/rel';

class NewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.news_box}>
                {content.map((item, index) => (
                    <div key={index} className={`${styles.box} ${index === 0 ? styles.box_l : styles.box_r}`}>
                        <a href={item.url} target="_blank" rel={rel} data-nomask>
                            <img src={item.thumbnail} alt={item.title} />
                        </a>
                        {item.isVideo ? (
                            <div className={styles.btn}>
                                <a href={item.url} target="_blank" rel={rel} data-nomask />
                            </div>
                        ) : (
                            ''
                        )}
                        <div className={styles.txt_bg} />
                        <div className={styles.txt}>
                            <a key={index} href={item.url} target="_blank" rel={rel}>
                                {item.title}
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default errorBoundary(NewsBox);
